import { cn } from "@/lib/utils";

interface FlashcardsDeckListItemProps {
  title: string;
  cardCount: number;
  isSelected: boolean;
  onSelect: () => void;
  className?: string;
}

const selectedSurface = "border-secondary bg-secondary/10";
const unselectedSurface = "border-gray-200 bg-background hover:border-gray-300";

/**
 * Deck row in the Lernkarten picker — used to highlight a deck before study.
 */
const FlashcardsDeckListItem = ({
  title,
  cardCount,
  isSelected,
  onSelect,
  className,
}: FlashcardsDeckListItemProps) => {
  const surfaceClassName = isSelected ? selectedSurface : unselectedSurface;

  return (
    <button
      type="button"
      aria-current={isSelected ? "true" : undefined}
      onClick={onSelect}
      className={cn(
        // ps-2.5 plus the 2px border lines the title up with the module heading's ps-3.
        "w-full rounded-xl border-2 py-4 pe-4 ps-2.5 text-left transition-colors",
        "focus:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50",
        surfaceClassName,
        className
      )}
    >
      <span className="block font-semibold text-primary">{title}</span>
      <span className="mt-1 block text-sm text-muted-foreground">
        {cardCount} Karten
      </span>
    </button>
  );
};

export default FlashcardsDeckListItem;
